import { Group } from 'app/library/group/models/group';
import { User } from 'app/projects/user/src/lib/models/user';
import { IGroupMemberQuery } from '../interfaces/group-member.query.interface';

export class GroupMember {
    static label_singular = 'groupMember';
    static label_plural = 'groupMembers';

    static props_to_search = ['user', 'fullName', 'firstName', 'lastName'];

    id: string;
    group: Group;
    user: User;
    isAdmin: boolean;
    isFavourite: boolean;

    constructor(groupMember?: IGroupMemberQuery) {
        if (groupMember) {
            this.id = groupMember.id ? groupMember.id.toString() : null;
            this.group = new Group(groupMember.group);
            this.user = new User(groupMember.user);
            this.isAdmin = groupMember.is_admin;
            this.isFavourite = groupMember.is_favourite;
        } else {
            this.id = null;
            this.group = null;
            this.user = null;
            this.isAdmin = null;
        }
    }
}
